// extracted by mini-css-extract-plugin
export default {"main":"src-views-___error__main___HpLSc","text":"src-views-___error__text___U_JRb","subtext":"src-views-___error__subtext___BQ3wn"};